import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { RoleGuard } from '../guards'
import { ExperimentOutlined, SlidersOutlined } from '@ant-design/icons-vue'
import type { RouteRecordRaw } from 'vue-router'

export const org_admin_routes: RouteRecordRaw[] = [

]
